import React from "react";

interface IProps {
  checked: boolean;
  toggle: () => void;
}

const CheckBox = ({ checked, toggle }: IProps) => (
  <div
    className={`checkbox-wrap ${checked ? "checked" : ""}`}
    onClick={toggle}
  >
    <input
      type="checkbox"
      className={`checkbox ${checked ? "checked" : ""}`}
      checked={checked}
    />
  </div>
)

export default CheckBox;
